import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import { ProviderPromotionsPermissions } from '../../../../common/all/api/gen/CampaignDeliveryProvider';
import { PromotionsPermissionsAction, requestPromotionsPermissionAsyncAction } from './actions';

export interface PromotionsPermissionsState {
  result: ProviderPromotionsPermissions;
  fetchingState: NetworkRequestState;
  error?: Error;
  updateRequestState: NetworkRequestState;
}

const initialState: PromotionsPermissionsState = {
  result: {
    can_view_selected_items_menu_editor: false,
    should_skip_landing_page: false,
  },
  fetchingState: NetworkRequestState.unset,
  updateRequestState: NetworkRequestState.unset,
};

export const promotionsPermissionReducer = (
  state: PromotionsPermissionsState = initialState,
  action: PromotionsPermissionsAction,
): PromotionsPermissionsState => {
  switch (action.type) {
    case getType(requestPromotionsPermissionAsyncAction.request): {
      return {
        ...state,
        result: null,
        fetchingState: NetworkRequestState.waiting,
      };
    }
    case getType(requestPromotionsPermissionAsyncAction.success): {
      return {
        ...state,
        result: action.payload.result,
        fetchingState: NetworkRequestState.success,
      };
    }
    case getType(requestPromotionsPermissionAsyncAction.failure): {
      return {
        ...state,
        fetchingState: NetworkRequestState.failure,
      };
    }

    default: {
      return state;
    }
  }
};
